import { Component, OnInit, Input } from '@angular/core';
import { AppConfig } from '../../../../app.config';

@Component({
  selector: 'app-heart-button',
  templateUrl: './heart-button.component.html',
  styleUrls: ['./heart-button.component.scss']
})
export class HeartButtonComponent implements OnInit {
  @Input('selected')
  selected: boolean;
  @Input('clear')
  clear: boolean;

  @Input('disableClick')
  disableClick: boolean;
  @Input('selectToolTip')
  selectToolTip: string;
  @Input('deselectToolTip')
  deselectToolTip: string;

  disableHover: boolean;

  constructor() {}

  ngOnInit() {
    this.disableHover = AppConfig.isTouchScreen;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/buttons/heart-button/heart-button.component.ts